import React from "react";
import Ressourcenplanung from "../Ressourcenplanung";

const RessourcenplanungWidget = () => (
  <div className="widget-content-scroll">
    <Ressourcenplanung readOnly={true} />
  </div>
);

export default RessourcenplanungWidget;
